import { Youtube } from "lucide-react";
import {
  PYCRAY_FORGE_YOUTUBE_LABEL,
  PYCRAY_FORGE_YOUTUBE_URL,
} from "../../constants/pycray-forge-youtube";

const iconLinkClass =
  "inline-flex items-center justify-center shrink-0 text-[#991B1B] hover:text-[#7F1D1D] transition-colors";

export default function PyCrayForgeYoutubeButton({
  className = "",
  compact = false,
  footer = false,
}) {
  const iconSize = compact ? "w-7 h-7" : footer ? "w-6 h-6" : "w-8 h-8";

  if (footer) {
    return (
      <a
        href={PYCRAY_FORGE_YOUTUBE_URL}
        target="_blank"
        rel="noopener noreferrer"
        className={`inline-flex items-center justify-center gap-2 rounded-full bg-navy text-white border border-teal/30 hover:bg-[#162d4a] font-medium transition-colors text-center px-4 sm:px-5 py-2.5 text-sm w-full sm:w-auto shadow-sm shadow-black/10 ${className}`}
        title={PYCRAY_FORGE_YOUTUBE_LABEL}
      >
        <Youtube className="w-5 h-5 shrink-0 text-[#991B1B]" aria-hidden />
        <span className="leading-snug">{PYCRAY_FORGE_YOUTUBE_LABEL}</span>
      </a>
    );
  }

  return (
    <a
      href={PYCRAY_FORGE_YOUTUBE_URL}
      target="_blank"
      rel="noopener noreferrer"
      className={`${iconLinkClass} ${className}`}
      aria-label={PYCRAY_FORGE_YOUTUBE_LABEL}
      title={PYCRAY_FORGE_YOUTUBE_LABEL}
    >
      <Youtube className={iconSize} aria-hidden />
    </a>
  );
}
